import { DataSales } from "../components/DataSales";
import { SalesContextProvider } from "../context/useSalesColumnContext";

export function DataSalesPage() {
  return (
    <SalesContextProvider>
      <DataSales />
    </SalesContextProvider>
  );
}